export const HTTP_HEADERS = {
  getAuthorizationHeader: (accessToken: string): string => `Bearer ${accessToken}`,
  getUserType: (value: { isProfessional: boolean }): 'professional' | 'patient' => value.isProfessional ? 'professional' : 'patient',
  clientType: {
    webApp: 'webapp',
    mobileApp: 'mobapp'
  }
};
